define((require) => {
    "use strict";

    var _                  = require("underscore"),
        EditBehavior       = require("ui/behaviors/EditBehavior"),
        ImageThumbnailView = require("ui/assets/image/ImageThumbnailView"),
        template           = require("ui/projects/image/ProjectImageView.tpl");

    /**
     * Subclass of ImageThumbnailView representing the item view for the Image lightbox in a
     * project context.
     *
     * @class ProjectAttachImageView
     * @see ImageThumbnailView
     */
    return ImageThumbnailView.extend({

        template: template,

        templateHelpers: function() {
            var parentTemplateHelpers = this.__super();

            // Extending the parent templateHelpers.
            return _.defaults({
                showImageActionsPanel: this.options.showImageActionsPanel,
                isEditable: false
            }, parentTemplateHelpers);
        },

        _imageSelected: false,

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".js-name",
                    // Disable event binding of the field because click events should be disabled
                    // on images.
                    enableFieldEvents: false,
                    hideIcon: true
                }]
            },
            altTextEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".js-alt-text",
                    enableFieldEvents: false,
                    hideIcon: true
                }]
            }
        },

        events: {
            "click": function() {
                this._imageSelected = !this._imageSelected;
                this.options.selectHandler(this.model, this._imageSelected);
                this.$el.toggleClass("selected");
            }
        },

        onRender: function() {
            this.__super();

            var projectContext = this.options.projectContext;

            if (projectContext.project.containsImage(this.model.get("id"))) {
                this.$el.addClass("in-project");
            } else {
                this.$el.removeClass("in-project");
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/image/ProjectAttachImageView.js